import { render, staticRenderFns } from "./DataSource.vue?vue&type=template&id=b9dff684&"
import script from "./DataSource.vue?vue&type=script&lang=js&"
export * from "./DataSource.vue?vue&type=script&lang=js&"
import style0 from "./DataSource.vue?vue&type=style&index=0&id=b9dff684&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports